/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2544
 */

module.exports = function (e) {
  var t = []
  if (null != e) {
    for (var n in Object(e)) t.push(n)
  }
  return t
}
